import { makeStyles } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import cx from "classnames";

export default function IconButton({
  children,
  isActive,
  onClick,
  isSpecial = false,
  disabled = false,
  cypressId = "",
  hint = "",
  onMouseEnter = () => {},
  onMouseLeave = () => {},
}) {
  const classes = useStyles();

  return (
    <Tooltip title={hint || ""} arrow placement="right">
      <button
        className={cx(classes.button, {
          [classes.button_active]: isActive,
          [classes.button_special]: isSpecial,
          [classes.button_disabled]: disabled,
        })}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={disabled ? () => {} : onClick}
        // @ts-ignore
        cypress_id={cypressId}
      >
        {children}
      </button>
    </Tooltip>
  );
}

const useStyles = makeStyles({
  button: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "56px",
    height: "66px",
    borderRadius: 8,
    cursor: "pointer",
    color: "var(--color-surface-panel)",
    padding: "3px",
    marginBottom: "15px",

    transition: "background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    willChange: "background-color, box-shadow",

    "&:hover, &:focus-visible": {
      background: "var(--color-brand-hover)",
    },

    "&:focus": {
      outline: "none",
    },
    "&:disabled": {
      opacity: 0.1,
    },
  },
  button_active: {
    extend: "button",
    background: "var(--color-brand-400)",
    border: "1px solid var(--color-brand-400)",
    boxShadow: "0 0 0 1px var(--color-brand-400)",

    "&:hover, &:focus-visible": {
      background: "var(--color-brand-400)",
      boxShadow: "0 0 0 1px var(--color-brand-400)",
    },
  },
  button_special: {
    extend: "button",
  },
  button_disabled: {
    extend: "button",

    opacity: 0.1,
  },
});
